// Section 24.7: opaque ids ('p0042', 'h0007', 'b0003') minted from counters held in state.
// Counters rather than rng draws keep id minting independent of the random stream (ADR-0010).
import type {
  BuildOrderId,
  BuildingId,
  CaseId,
  GroupId,
  HouseholdId,
  IdKind,
  PersonId,
} from './types';

const prefixes: Record<IdKind, string> = {
  person: 'p',
  household: 'h',
  building: 'b',
  order: 'o',
  case: 'c',
  group: 'g',
};

interface IdCounters {
  nextIds: Record<IdKind, number>;
}

export function formatId(kind: IdKind, n: number): string {
  return `${prefixes[kind]}${String(n).padStart(4, '0')}`;
}

interface IdTypes {
  person: PersonId;
  household: HouseholdId;
  building: BuildingId;
  order: BuildOrderId;
  case: CaseId;
  group: GroupId;
}

/** Mint the next id of a kind, advancing the counter on the (draft) state. */
export function mintId<K extends IdKind>(state: IdCounters, kind: K): IdTypes[K] {
  const n = state.nextIds[kind];
  state.nextIds[kind] = n + 1;
  return formatId(kind, n) as IdTypes[K];
}

export function emptyIdCounters(): Record<IdKind, number> {
  return { person: 1, household: 1, building: 1, order: 1, case: 1, group: 1 };
}
